









import { defineComponent } from '@vue/composition-api';
import AdCampaign from '@/bundles/Ad/models/AdCampaign';
import { useAdCampaign } from '@/bundles/Ad/composables/useAdCampaign';
import { EditAdCampaignDto } from '@/bundles/Ad/dto';

import AdCampaignFormBase from '@/bundles/Ad/components/AdCampaignFormBase.vue';

export default defineComponent({
  name: 'AdCampaignEditForm',

  components: {
    AdCampaignFormBase,
  },

  emits: ['form:close', 'item:refresh'],

  props: {
    adCampaignEntry: {
      type: AdCampaign,
      required: true,
    },
  },

  setup (_, { emit }) {
    const { editLoading, editCampaign } = useAdCampaign();
    async function updateEventHandler (payload: EditAdCampaignDto & { id: number }) {
      const id = payload.id;
      delete payload.id;
      await editCampaign(id, payload);
      emit('form:close');
      emit('item:refresh');
    }
    return {
      editLoading,
      updateEventHandler,
    };
  },
});
